import { Link } from 'react-router-dom';
import { useAuth } from '../../lib/auth';

export function Header() {
  const { session, signOut } = useAuth();
  return (
    <header className="dark-surface border-b-2 border-coral bg-surface shadow-sm">
      <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link
          to="/"
          aria-label="RoleForge home"
          className="inline-flex rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-4 focus-visible:ring-offset-surface"
        >
          <img
            src="/roleforge-logo-horizontal.svg"
            alt="RoleForge — Build your AI workforce"
            className="h-14 w-auto"
          />
        </Link>
        {session && (
          <button
            type="button"
            onClick={signOut}
            className="rounded-lg border border-line px-4 py-2 text-sm font-medium text-graphite transition hover:border-coral hover:bg-card hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-2 focus-visible:ring-offset-surface"
          >
            Sign out
          </button>
        )}
      </div>
    </header>
  );
}
